module.exports = __webpack_public_path__ + "img/product-attr02.727fb050.png";